<template>
    <div>
        <v-menu offset-y left origin="right top" z-index="99" content-class="notification-dropdown right-0" transition="slide-y-transition" :nudge-top="$vuetify.breakpoint.name === 'xs' ? '-10' : '2'" :nudge-right="$vuetify.breakpoint.name === 'sm' ? '10' : '0'">
            <v-btn v-if="$vuetify.breakpoint.name === 'sm' || $vuetify.breakpoint.name === 'xs'" slot="activator" icon large>
                <v-icon>zmdi zmdi-download</v-icon>
            </v-btn>
            <v-btn v-else slot="activator" flat :loading="processing" :disabled="processing">
                <v-icon left>zmdi zmdi-download</v-icon> Mipres
            </v-btn>
            <div class="dropdown-content">
                <div class="dropdown-top d-custom-flex justify-space-between primary">
                    <span class="white--text fw-bold text-xs-center">Opciones facturación</span>
                </div>
                <v-list class="dropdown-list">
                    <template v-for="downloadLink in downloadLinks">
                        <v-list-tile @click="downloadLink.type === 'prescriptionsync' ? openDialogDownloadHistorico(downloadLink.type) : openDialogDownloadFacturacion()" :key="downloadLink.id">
                            <v-icon left :color="downloadLink.color">{{downloadLink.icon}}</v-icon>
                            <span>{{downloadLink.title}}</span>
                        </v-list-tile>
                    </template>
                </v-list>
            </div>
        </v-menu>
        <download-facturacion-dialog
                ref="dialogDF"
                @onProcessing="val => processing = val"
        >
        </download-facturacion-dialog>
        <download-historico-dialog
                v-if="permisos && permisos.prescripciones && permisos.prescripciones.sincronizar"
                ref="dialogDH"
                type="sincronización"
                @onProcessing="val => processing = val"
                @onSuccess="val => reloadTable(val)"
        >
        </download-historico-dialog>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
   export default{
       components: {
           DownloadFacturacionDialog: () => import('@/components/Facturacion/DownloadFacturacionDialog')
       },
       data: () => ({
           downloadLinks: [
               {
                   id: 1,
                   title: 'Descargar por prescripción',
                   icon: 'fas fa-file-invoice-dollar',
                   color: 'primary'
               }
           ],
           processing: false
       }),
       computed: {
           ...mapGetters([
               'typeEmpresa'
           ]),
           permisos() {
               return {
                   prescripciones: this.$store.getters.getPermissionModule('prescripciones')
               }
           }
       },
       created() {
           if (this.permisos.prescripciones && this.permisos.prescripciones.sincronizar && ['IPS', 'Farmacia'].find(x => x === this.typeEmpresa)) {
               this.downloadLinks.push({
                   id: 3,
                   title: 'Sincronizar por prescripción',
                   descripction: 'Sincroniza todos los procesos especificando el número de una prescripción',
                   icon: 'ti ti-wand',
                   color: 'blue',
                   type: 'prescriptionsync'
               })
           }
       },
      methods: {
          reloadTable (reload) {
              reload && this.$store.commit('reloadTable', 'tableFacturacion')
          },
          openDialogDownloadFacturacion () {
              this.$refs.dialogDF.open()
          },
          openDialogDownloadHistorico(type) {
              this.$refs.dialogDH.open(type)
          }
      }
   }
</script>